export default __webpack_public_path__ + "static/media/IMG_8986.679415ad.jpg";